import React from 'react';
import { render, screen } from '@testing-library/react';
import MissingDetail from './MissingDetail';

jest.mock('components/styleguide/icon/Icon', () => ({
  __esModule: true,
  default: ({ name, ...props }: any) => <span data-icon={name} {...props} />,
}));

describe('MissingDetail', () => {
  it('renders the label text', () => {
    render(<MissingDetail icon="briefcaseBusiness" label="Add your job title" />);
    expect(screen.getByText('Add your job title')).toBeInTheDocument();
  });

  it('renders the icon', () => {
    const { container } = render(<MissingDetail icon="briefcaseBusiness" label="Add your job title" />);
    expect(container.querySelector('[data-icon="briefcaseBusiness"]')).toBeInTheDocument();
  });

  it('applies custom className', () => {
    const { container } = render(<MissingDetail icon="user" label="Missing" className="custom" />);
    expect(container.firstChild).toHaveClass('custom');
  });

  describe('accessibility', () => {
    it('marks icon as aria-hidden', () => {
      const { container } = render(<MissingDetail icon="user" label="Add name" />);
      expect(container.querySelector('[data-icon="user"]')).toHaveAttribute('aria-hidden', 'true');
    });

    it('label text is accessible', () => {
      render(<MissingDetail icon="user" label="Add your name" />);
      expect(screen.getByText('Add your name')).toBeInTheDocument();
    });
  });
});
